import { useModal } from '@ebay/nice-modal-react'
import { styled } from '@linaria/react'
import { Link } from '@tanstack/router'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import useGeoCheck from '../../hooks/useGeoCheck'
import { useBoundStore } from '../../store/store'
import LoginModal from '../common/log-in-modal'
import Icon from '../icon'
import WalletManagementModal from '../wallet-management/wallet-management-modal'

const Container = styled.div`
  transition: all 0.2s ease-in-out;
  overflow: hidden;
  border: none;
  .theme-dark & {
    border-bottom: 1px solid #1f223c;
  }
  .theme-light & {
    border-bottom: 1px solid #f5f6f9;
  }
`

const Head = styled.div`
  padding: 10px 20px;
  svg {
    transition: all 0.2s ease-in-out;
  }
  span {
    font-size: 12px;
    text-transform: uppercase;
    color: var(--txt);
  }
  img {
    max-width: 25px;
    max-height: 25px;
  }
`

const DropdownItem = styled.span`
  padding: 8px 0;
  &:last-child {
    border: none;
  }
  span {
    font-size: 14px;
    font-weight: 400;
    color: #fff;
  }
  div {
    width: 30px;
  }
  img {
    max-width: 20px;
    max-height: 20px;
  }
`
const DropdownContainer = styled.div`
  border: none;
  padding: 6px 0 6px 20px;
  background-color: var(--secondary);
`

const TabLabel = styled.p`
  margin-left: 10px;
  margin-right: 10px;
  color: var(--highlight);
`
type CashierProps = {
  closeProfileDrawer: () => void
}

const CashierDrawerTabs = ({ closeProfileDrawer }: CashierProps) => {
  const { t } = useTranslation(['drawer', 'cashier'])
  const username = useBoundStore(state => state.user.username)
  const logInModal = useModal(LoginModal)
  const walletManagement = useModal(WalletManagementModal)
  const { geoCheck } = useGeoCheck()
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Container style={{ height: isOpen ? '217px' : '39px' }}>
      <Head
        className="flx-btw-ctr"
        onClick={() => setIsOpen(prev => (prev ? false : true))}>
        <div className="flx-str-ctr">
          <TabLabel>{t('cashier').toUpperCase()}</TabLabel>
        </div>
        <Icon
          id="triangle-down"
          width="16"
          height="10"
          fill="#46aef7"
          style={{ transform: `rotate(${isOpen ? '-180' : '0'}deg)` }}
        />
      </Head>
      <DropdownContainer>
        <DropdownItem
          className="flx-str-ctr"
          onClick={() => {
            closeProfileDrawer()
            if (!username) {
              return geoCheck(logInModal.show)
            }
            walletManagement.show({})
          }}>
          <TabLabel>{t('cashier:deposit')}</TabLabel>
        </DropdownItem>
        <DropdownItem
          className="flx-str-ctr"
          onClick={() => {
            closeProfileDrawer()
            if (!username) {
              return geoCheck(logInModal.show)
            }
            walletManagement.show({ walletManagementDefaultTab: { tab: 1 } })
          }}>
          <TabLabel>{t('cashier:withdrawals')}</TabLabel>
        </DropdownItem>
        <Link to={username ? '/profile/transaction-history' : undefined}>
          <DropdownItem
            className="flx-str-ctr"
            onClick={() => {
              closeProfileDrawer()
              if (!username) {
                return geoCheck(logInModal.show)
              }
            }}>
            <TabLabel>{t('transactions')}</TabLabel>
          </DropdownItem>
        </Link>
        <Link
          to={username ? '/profile/financial-transaction' : undefined}
          search={{ tab: 'all' }}>
          <DropdownItem
            className="flx-str-ctr"
            onClick={() => {
              closeProfileDrawer()
              if (!username) {
                return geoCheck(logInModal.show)
              }
            }}>
            <TabLabel>{t('financial-transactions')}</TabLabel>
          </DropdownItem>
        </Link>
        {/* <Link to={username ? '/profile/claim-history' : undefined}>
          <DropdownItem
            className="flx-str-ctr"
            onClick={() => {
              closeProfileDrawer()
              if (!username) {
                return geoCheck(logInModal.show)
              }
            }}>
            <TabLabel>Reclamado Historico</TabLabel>
          </DropdownItem>
        </Link> */}
      </DropdownContainer>
    </Container>
  )
}

export default CashierDrawerTabs
